import { ProcessedCustomLinkItem, SidebarMenuItemProps } from '../../../types';
import { useIsActiveLink } from '../useIsActiveLink';

import { SidebarItem } from './SidebarItem';
import { SidebarWidgetItem } from './SidebarWidgetItem';

export const SidebarCustomLinkItem = ({
  item,
  showIcon = true,
  isInDoubleDrop = false,
}: SidebarMenuItemProps<ProcessedCustomLinkItem['type']>) => {
  const { link, blank, title, iconName, external_system: external } = item;

  const isActiveItem = useIsActiveLink(link);

  if (external) {
    return (
      <SidebarWidgetItem
        item={item}
        showIcon={showIcon}
        isInDoubleDrop={isInDoubleDrop}
      />
    );
  }

  return (
    <SidebarItem
      href={link}
      iconName={iconName}
      aqaClass={`aqa_${title}`}
      title={title}
      isActive={isActiveItem}
      isCustom
      blank={blank}
      showIcon={showIcon}
      isInDoubleDrop={isInDoubleDrop}
    />
  );
};
